import Dinero from 'dinero.js'
import PropTypes from 'prop-types'
import {Button, Flex, Text} from '@chakra-ui/react'
import {ArrowRightIcon} from '../../../../icons'
import {destructureAmount} from '../../../../../utils/formatter'
import {openTab} from '../../../../../utils/browser'

const InvoiceOwing = ({dueAmount, buttonText, paymentUrl}) => {
  const [_s, unit, delimeter, subunit] = destructureAmount(dueAmount)

  return (
    <Flex
      justifyContent="space-between"
      flexDirection="row"
      alignItems="flex-start"
    >
      <Flex data-testid="summary-total" letterSpacing={0}>
        <Text fontSize="4xl" mt="6px">
          {unit}
        </Text>
        <Text fontSize="md">
          {delimeter}
          {subunit}
        </Text>
      </Flex>
      <Button
        variant="primary"
        colorScheme="primary"
        size="md"
        rightIcon={<ArrowRightIcon />}
        onClick={openTab(paymentUrl)}
      >
        {buttonText}
      </Button>
    </Flex>
  )
}

InvoiceOwing.propTypes = {
  dueAmount: PropTypes.objectOf(Dinero).isRequired,
  buttonText: PropTypes.string.isRequired,
  paymentUrl: PropTypes.string.isRequired,
}

export default InvoiceOwing
